export default __webpack_public_path__ + "static/media/0777BLEU.dc1c304c.pdf";